import { render, staticRenderFns } from "./BtnAtualizarDetalheEntrega.vue?vue&type=template&id=50815a9f"
import script from "./BtnAtualizarDetalheEntrega.vue?vue&type=script&lang=js"
export * from "./BtnAtualizarDetalheEntrega.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports